/** Display-only integer percentages; pricing values and bar widths are unchanged. */
export function splitPercentages(values: number[]): number[] {
  const total = values.reduce((sum, value) => sum + Math.max(0, value), 0);
  if (!total) return values.map(() => 0);
  const exact = values.map(value => Math.max(0, value) * 100 / total);
  const result = exact.map(Math.floor);
  const rank = exact.map((value, index) => ({ index, fraction: value - result[index] })).sort((a, b) => b.fraction - a.fraction);
  const remainder = 100 - result.reduce((sum, value) => sum + value, 0);
  rank.slice(0, remainder).forEach(({ index }) => result[index]++);
  return result;
}
